import React, { useMemo } from 'react';
import { Typography } from '@components/atoms/typography';
import { Autocomplete } from '@components/moleculs/autocomplete';
import {
    endYearRangeDefault,
    startYearRangeDefault,
} from '@components/moleculs/date-pickers/date-picker-header/contants';
import type { DatePickerHeaderProps } from '@components/moleculs/date-pickers/date-picker-header/types';
import { useMonthOptions } from '@components/moleculs/date-pickers/hooks/use-month-options';
import { TextField } from '@components/moleculs/text-field';
import { getMonth, getYear } from 'date-fns';

export const DatePickerHeader = (props: DatePickerHeaderProps) => {
    const {
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
        startYearRange = startYearRangeDefault,
        endYearRange = endYearRangeDefault,
    } = props;

    const range = (start: number, end: number) =>
        new Array(end - start).fill(undefined).map((d, i) => i + start);
    const years = useMemo(
        () => range(startYearRange, endYearRange),
        [endYearRange, startYearRange],
    );
    const months = useMonthOptions();

    return (
        <div className='datepicker-header'>
            <div className='datepicker-header__main'>
                <button
                    type='button'
                    className='datepicker-header__button datepicker-header__button--previous'
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}
                >
                    Before
                </button>

                <Typography variant='small-text-bold' color='text-main'>
                    {months[getMonth(date)]} {getYear(date)}
                </Typography>

                <button
                    type='button'
                    className='datepicker-header__button datepicker-header__button--next'
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                >
                    Next
                </button>
            </div>
            <div className='datepicker-header__controls'>
                <Autocomplete
                    value={months[getMonth(date)]}
                    fullWidth={true}
                    disablePortal={true}
                    onChange={(_, val) => {
                        changeMonth(months.indexOf(val));
                    }}
                    multiple={false}
                    disableClearable={true}
                    renderInput={(params) => <TextField inputSize='s' {...params} />}
                    options={months}
                />

                <Autocomplete
                    value={getYear(date)}
                    fullWidth={true}
                    disablePortal={true}
                    className='datepicker-header__year'
                    freeSolo={false}
                    getOptionLabel={(option) => option.toString()}
                    onChange={(_, val) => {
                        changeYear(Number(val));
                    }}
                    multiple={false}
                    disableClearable={true}
                    renderInput={(params) => <TextField inputSize='s' {...params} />}
                    options={years}
                />
            </div>
        </div>
    );
};
